<template>
	<form
		data-vv-scope="editPasswordForm"
		@submit.prevent="action('editPasswordForm')"
	>
		<div class="row pt-3">
			<div class="col-5 col-lg-2">
				<p id="user-account-setting-current-password"
							data-test="profileCurrentPasswrdHeading">
					Current Password
				</p>
			</div>
			<div class="col-7 col-lg-5">
				<input
					type="password"
					name="currentpassword"
					:disabled="!editPassword"
					class="form-control"
					aria-describedby="Current Password"
					:placeholder="editPassword?'Current Password' : '******'"
					id="user-account-setting-current-password-input"
					v-model="passwordData.currentPassword"
					autocomplete="off"
					v-validate="'required|min:6'"
					:class="(showPasswordFormErrors &&
                    errors.has('editPasswordForm.currentpassword'))?
                    'is-invalid':''"
					data-test="profileCurrentPasswrdInput"
				>
				<!--fix these divs-->
				<div
					class="invalid-feedback"
					v-if="showPasswordFormErrors"
					v-show="errors.has('editPasswordForm.currentpassword')"
					id="user-account-setting-current-password-error"
					data-test="profileCurrentPasswrdInputError"
				>
					{{errors.first('editPasswordForm.currentpassword')}}
				</div>
				<div
					class="invalid-feedback"
					v-if="currentPasswordError"
					data-test="profileCurrentPasswrd"
					id="profileCurrentPasswrd"
				>
					{{currentPasswordError}}
				</div>
			</div>
		</div>
		<div
			class="row pt-3"
			v-if="editPassword"
		>
			<div class="col-5 col-lg-2">
				<p id="user-account-setting-new-password-head"
							data-test="profileNewPasswrdHeading">
					New Password
				</p>
			</div>
			<div class="col-7 col-lg-5">
				<input
					:disabled="!editPassword"
					class="form-control"
					aria-describedby="New password"
					placeholder="New Password"
					type="password"
					name="newpassword"
					id="user-account-setting-new-password-input"
					ref="newpassword"
					v-model="passwordData.newPassword"
					autocomplete="off"
					v-validate="'required|min:6'"
					:class="(showPasswordFormErrors &&
                  errors.has('editPasswordForm.newpassword'))?
                  'is-invalid':''"
					data-test="profileNewPasswrdInput"
				>
				<div
					class="invalid-feedback"
					v-if="showPasswordFormErrors"
					v-show="errors.has('editPasswordForm.newpassword')"
					id="user-account-setting-new-password-error"
					data-test="profileNewPasswrdInputError"
				>
					{{errors.first('editPasswordForm.newpassword')}}
				</div>
			</div>
		</div>
		<div
			class="row pt-3"
			v-if="editPassword"
		>
			<div class="col-5 col-lg-2">
				<p id="user-account-setting-confirm-password-head"
							data-test="profileConfirmPasswrdHeading">Confirm Password</p>
			</div>
			<div class="col-7 col-lg-5">
				<input
					:disabled="!editPassword"
					class="form-control"
					aria-describedby="state"
					placeholder="Confirm Password"
					id="user-account-setting-confirm-password-input"
					type="password"
					name="confirmpassword"
					v-model="passwordData.confirmPassword"
					autocomplete="off"
					v-validate="'required|confirmed:newpassword'"
					:class="(showPasswordFormErrors &&
                  errors.has('editPasswordForm.confirmpassword'))?
                  'is-invalid':''"
					data-test="profileConfirmPasswrdInput"
				>
				<div
					class="invalid-feedback"
					v-if="showPasswordFormErrors"
					v-show="errors.has('editPasswordForm.confirmpassword')"
					id="user-account-setting-confirm-password-error"
					data-test="profileConfirmPasswrdInputError"
				>
					<!--{{errors.first('editPassword.confirmpassword')}}-->
					The password confirmation does not match.
				</div>
			</div>
		</div>
		<div
			class="row mb-3 pt-3"
			v-if="editPassword"
		>
			<button
				class="btn btn-primary btn-xs ml-3 order-2"
				id="user-account-setting-save-btn"
				data-test="profileEditPasswrdSaveBtn"
			>
				Save and Continue
			</button>
			<button
				class="btn btn-outline-dark btn-xs ml-3 order-1"
				id="user-account-setting-cancel-btn"
				@click.prevent="cancelPasswordDataAction"
				data-test="profileEditPasswrdCancelBtn"
			>
				Cancel
			</button>
		</div>
	</form>
</template>

<script>
export default {
	name: 'edit-password-form',
	data () {
		return {
			showPasswordFormErrors: false,
			editPasswordData: false
		}
	},
	props: {
		passwordData: {},
		editPassword: {
			type: Boolean,
			default: false
		},
		currentPasswordError: null
	},
	watch: {
		editPassword () {
			this.editPasswordData = this.editPassword
		}
	},
	mounted () {
		this.editPasswordData = this.editPassword
	},
	methods: {
		action (scope) {
			this.$validator.validateAll(scope).then((result) => {
				if (result) {
					this.showPasswordFormErrors = false
					this.$emit('passwordDataSubmit', this.passwordData)
				} else {
					this.showPasswordFormErrors = true
				}
			})
		},
		cancelPasswordDataAction () {
			this.editPasswordData = !this.editPasswordData
			this.$emit('cancelPasswordData', this.editPasswordData)
		}
	}
}
</script>

<style scoped>

</style>
